<script>
import DefaultLayout from "./layouts/default.vue";
import BlankLayout from "./layouts/blank.vue";
import { getSiteConfig } from "@/api/common";

export default {
  name: "App",
  components: {
    DefaultLayout,
    BlankLayout,
  },
  data() {
    return {
      layoutRef: "",
      siteConfig: {},
    };
  },
  watch: {
    "$route.path": {
      handler() {
        const { meta } = this.$route;

        if (meta.layout) {
          this.layoutRef = meta.layout;
        } else {
          this.layoutRef = "default";
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getSiteConfig();
  },
  methods: {
    getSiteConfig() {
      getSiteConfig().then(({ data }) => {
        this.siteConfig = data;

        let favicon = document.querySelector('link[rel="icon"]');
        if (favicon) {
          favicon.href = data.titleBarLogo;
        } else {
          favicon = document.createElement("link");
          favicon.rel = "icon";
          favicon.href = data.titleBarLogo;
          document.head.appendChild(favicon);
        }
      });
    },
  },
  render(h) {
    const { layoutRef, siteConfig } = this;
    return h(layoutRef === "default" ? "DefaultLayout" : "BlankLayout", {
      props: { siteConfig },
    });
  },
};
</script>
